"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _styledComponents = require("styled-components");
var _recharts = require("recharts");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PieChart = _ref => {
  let {
    config = [],
    data = [],
    disabled = false,
    height = 400,
    legend = false,
    minHeight,
    minWidth,
    onClick,
    selected,
    tooltip = false,
    width = "100%"
  } = _ref;
  const {
    primaryColor
  } = (0, _styledComponents.useTheme)();
  const handleClick = (pieData, index) => {
    if ((0, _isEmpty.default)(pieData) || !onClick || disabled) return;
    onClick(_objectSpread(_objectSpread({}, pieData), {}, {
      index
    }));
  };
  const CustomTooltip = _ref2 => {
    var _payload$;
    let {
      active,
      payload
    } = _ref2;
    if (!active || (0, _isEmpty.default)(payload) || (0, _isEmpty.default)(config)) return null;
    const {
      dataKey,
      payload: dataPayload
    } = (_payload$ = payload[0]) !== null && _payload$ !== void 0 ? _payload$ : {};
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.TooltipContainer, {
      tabIndex: "-1",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.TooltipValue, {
        margin: "0px",
        children: [dataPayload === null || dataPayload === void 0 ? void 0 : dataPayload.label, ": ", dataPayload[dataKey]]
      })
    });
  };
  const legendPayload = config.map(_ref3 => {
    let {
      fill = primaryColor,
      label: value
    } = _ref3;
    return {
      color: fill,
      type: 'square',
      value
    };
  });
  const chartProps = {
    data,
    height: 400,
    margin: '0px',
    opacity: disabled ? 0.4 : 1,
    width: 400
  };
  const containerProps = {
    height,
    minHeight,
    minWidth,
    width
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.ResponsiveContainer, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.PieChart, _objectSpread(_objectSpread({}, chartProps), {}, {
      children: [config.map((_ref4, configIndex) => {
        let {
          dataKey,
          fill = primaryColor,
          fontSize = 14,
          innerRadius = '0%',
          label,
          labelLine = false,
          outerRadius = '80%',
          tickFormatter = payload => "".concat(payload === null || payload === void 0 ? void 0 : payload.label, ": ").concat(payload[dataKey])
        } = _ref4;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Pie, {
          animationDuration: 600,
          data: data,
          dataKey: dataKey,
          label: tickFormatter ? _ref5 => {
            let {
              payload
            } = _ref5;
            return tickFormatter(payload);
          } : false,
          labelLine: labelLine,
          innerRadius: innerRadius,
          nameKey: label,
          outerRadius: outerRadius,
          children: data.map((pieData, cellIndex) => {
            const isSelected = selected && (typeof selected === 'string' ? pieData.key === selected : pieData.key === selected[configIndex]);
            const isSelectedStyle = isSelected ? {
              opacity: 1,
              stroke: primaryColor,
              strokeWidth: 1
            } : {};
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Cell, _objectSpread({
              cursor: onClick && !disabled ? 'pointer' : undefined,
              fill: fill,
              opacity: selected ? 0.6 : 1,
              style: {
                fontSize,
                outline: 'none'
              },
              onClick: () => handleClick(pieData, configIndex)
            }, isSelectedStyle), "cell-".concat(cellIndex));
          })
        }, configIndex);
      }), tooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Tooltip, {
        content: CustomTooltip,
        cursor: {
          fill: 'transparent'
        },
        wrapperStyle: {
          outline: 'none'
        }
      }), legend && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Legend, {
        payload: legendPayload
      })]
    }))
  }));
};
PieChart.propTypes = {
  config: _propTypes.default.arrayOf(_propTypes.default.shape({
    dataKey: _propTypes.default.string.isRequired,
    fill: _propTypes.default.string,
    innerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    label: _propTypes.default.string.isRequired,
    labelLine: _propTypes.default.bool,
    outerRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    tickFormatter: _propTypes.default.func
  })),
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
    label: _propTypes.default.string.isRequired
  })),
  disabled: _propTypes.default.bool,
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  legend: _propTypes.default.bool,
  minHeight: _propTypes.default.number,
  minWidth: _propTypes.default.number,
  onClick: _propTypes.default.func,
  selected: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  tooltip: _propTypes.default.bool,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
var _default = exports.default = PieChart;